/* eslint-disable filename-export/match-named-export */
import { hydrateRoot } from 'react-dom/client';
import { PageShell } from './PageShell';
import type { PageContextClient } from './types';

/**
 * Render page.
 *
 * @param pageContext Page context.
 */
function render(pageContext: PageContextClient): void {
  const { Page, pageProps } = pageContext;
  /**
   *
   */
  hydrateRoot(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.getElementById('page-view')!,
    <PageShell pageContext={pageContext}>
      <Page {...pageProps} />
    </PageShell>
  );
}
export { render };
